// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__25XYv","header":"ReportDetails_header__IjV9_","title":"ReportDetails_title__33Ty3","left":"ReportDetails_left__g-g7q"};